import { AxiosPromise } from 'axios';
import { IQuestionnaireFormValues } from '../form';
import { instance } from '../../../../services';

const updateQuestionnaire = (data: IQuestionnaireFormValues): AxiosPromise => {
  const { id } = data;

  return instance.put(`/api/questionnaires/${id}`, data);
};

export default updateQuestionnaire;
